module.exports = __webpack_public_path__ + "img/other-icon-img4.c1a87d79.svg";